import { render, staticRenderFns } from "./NursingRecord.vue?vue&type=template&id=6d4a4066&"
import script from "./NursingRecord.vue?vue&type=script&lang=js&"
export * from "./NursingRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports